/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiParameter } from '../../models/AaiParameter';
import { Node } from '../../../core/models/Node';

/**
 * @author Jakub Senko<jsenko@redhat.com>
 * @param {Node} parent
 * @param {string} name
 * @class
 * @extends AaiParameter
 */
export class Aai20Parameter extends AaiParameter {
    public constructor(parent? : any, name? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof name === 'string') || name === null)) {
            let __args = arguments;
            super(parent, name);
        } else if(((typeof parent === 'string') || parent === null) && name === undefined) {
            let __args = arguments;
            let name : any = __args[0];
            super(name);
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && name === undefined) {
            let __args = arguments;
            super(parent);
        } else throw new Error('invalid overload');
    }
}
Aai20Parameter["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20Parameter";
Aai20Parameter["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.core.models.common.INamed"];




